export const CONTRACT_ADDRESS = "0x421C98710E16ECA364F08a3e96aDDf7212C735EB";
